import { Button, Menu } from "antd";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useContext } from "react";
import { context } from "../../context/context";

function Sidenav({ color }) {
    const { pathname } = useLocation();
    const page = pathname.replace("/", "");
    const { setOstan, setShahrestan, setShahr, setForceUpdate } =
        useContext(context);
    const handleShowOstan = () => {
        setOstan(true);
        setShahrestan(false);
        setShahr(false);
        setForceUpdate(20);
    };
    const iran = [
        <svg
            fill="#000000"
            version="1.1"
            id="Layer_1"
            width="24px"
            height="24px"
            viewBox="0 0 260 239"
            enable-background="new 0 0 260 239"
        >
            <g id="SVGRepo_bgCarrier" stroke-width="0" />
            <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
            />

            <g id="SVGRepo_iconCarrier">
                <path d="M255.932,189.235l-16.664-11.191l-12.894-17.102l12.091-16.908l-10.072-9.318l-12.115-42.184l8.782-24.79l-4.427-17.661 l-57.89-23.249l-16.845,4.419l-8.004,9.293l-11.191,3.041l-2.603,8.588l-23.476,3.844L64.886,38.306L50.022,4.077L32.629,16.119 L19.565,13.54L12.559,2.422L2.001,5.147l6.131,43.352l15.301,25.764l-6.52,7.201l-0.657,19.341l6.787,11.434l17.273,14.864 l0.462,18.075l12.529,17.37l20.435-3.479l21.287,38.584l30.872,18.465l15.862,3.211l22.308-11.945l9.95,5.376l5.036,17.297 l28.609,4.403l26.566,2.117l8.661-1.825l2.408-15.862L258,211.3L255.932,189.235z" />{" "}
            </g>
        </svg>,
    ];
    const users = [
        <svg width="24px" height="24px" viewBox="0 0 20 20" fill="#000000">
            <g id="SVGRepo_bgCarrier" stroke-width="0" />

            <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
            />

            <g id="SVGRepo_iconCarrier">
                <rect x="0" fill="none" width="20" height="20" />
                <g>
                    <path d="M10 9.25c-2.27 0-2.73-3.44-2.73-3.44C7 4.02 7.82 2 9.97 2c2.16 0 2.98 2.02 2.71 3.81 0 0-.41 3.44-2.68 3.44zm0 2.57L12.72 10c2.39 0 4.52 2.33 4.52 4.53v2.49s-3.65 1.13-7.24 1.13c-3.65 0-7.24-1.13-7.24-1.13v-2.49c0-2.25 1.94-4.48 4.47-4.48z" />{" "}
                </g>
            </g>
        </svg>,
    ];
    const admin = [
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            viewBox="0 0 30 30"
            version="1.1"
            id="svg822"
        >
            <defs id="defs816" />
            <g id="layer1" transform="translate(0,-289.0625)">
                <path
                    d="M 11.916016 6.28125 A 4 4 0 0 0 7.9160156 10.28125 A 4 4 0 0 0 11.916016 14.28125 A 4 4 0 0 0 15.916016 10.28125 A 4 4 0 0 0 11.916016 6.28125 z M 8.4628906 15.115234 C 5.2252742 16.489124 3.0845987 19.623082 2.9824219 23.138672 C 5.1722039 25.642012 8.3828992 27.230469 11.972656 27.230469 C 13.939081 27.230469 15.782366 26.738864 17.416016 25.896484 C 16.972529 25.303803 16.599939 24.654546 16.285156 23.957031 C 15.297133 21.767701 14.789426 19.133132 14.728516 16.570312 L 14.722656 16.318359 L 12.001953 20.574219 L 8.4628906 15.115234 z M 22.037109 15.308594 C 20.292352 15.308594 17.177734 17.251953 17.177734 17.251953 C 17.287817 21.883593 19.126557 27.009156 22.037109 26.972656 C 22.040309 26.972626 22.043675 26.972696 22.046875 26.972656 C 22.864919 26.962256 23.588979 26.535536 24.179688 25.916016 C 24.770398 25.296496 25.255835 24.472265 25.654297 23.546875 C 26.45122 21.696085 26.896484 19.437792 26.896484 17.576172 L 26.896484 17.308594 L 26.671875 17.166016 C 26.671875 17.166016 25.951124 16.70805 25.029297 16.25 C 24.107471 15.79195 23.009546 15.308594 22.041016 15.308594 L 22.037109 15.308594 z M 22.037109 16.279297 L 22.041016 16.279297 C 22.641611 16.279297 23.726421 16.688174 24.597656 17.121094 C 25.326193 17.483104 25.720925 17.73488 25.896484 17.84375 C 25.857384 19.50574 25.45849 21.539389 24.759766 23.162109 C 24.392753 24.014469 23.950753 24.748774 23.476562 25.246094 C 23.003258 25.742454 22.526857 25.9928 22.037109 26 L 22.037109 16.279297 z "
                    transform="translate(0,289.0625)"
                    id="path852"
                />
            </g>
        </svg>,
    ];
    const content = [
        <svg width="24px" height="24px" viewBox="0 0 24 24">
            <path d="M1 6v12h9V6zm8 11H2V7h7zm-8 3h22v1H1zM1 3h22v1H1zm11 4h11v1H12zm0 3h11v1H12zm0 3h11v1H12zm0 3h11v1H12z" />
        </svg>,
    ];
    const place = [
        <svg fill="#000000" width="24px" height="24px" viewBox="0 0 24 24">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
        </svg>,
    ];
    const link = [
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.7285 3.88396C17.1629 2.44407 19.2609 2.41383 20.4224 3.57981C21.586 4.74798 21.5547 6.85922 20.1194 8.30009L17.6956 10.7333C17.4033 11.0268 17.4042 11.5017 17.6976 11.794C17.9911 12.0863 18.466 12.0854 18.7583 11.7919L21.1821 9.35869C23.0934 7.43998 23.3334 4.37665 21.4851 2.5212C19.6346 0.663551 16.5781 0.905664 14.6658 2.82536L9.81817 7.69182C7.90688 9.61053 7.66692 12.6739 9.51519 14.5293C9.80751 14.8228 10.2824 14.8237 10.5758 14.5314C10.8693 14.2391 10.8702 13.7642 10.5779 13.4707C9.41425 12.3026 9.44559 10.1913 10.8809 8.75042L15.7285 3.88396Z"
                fill="#1C274C"
            />
            <path
                d="M14.4851 9.47074C14.1928 9.17728 13.7179 9.17636 13.4244 9.46868C13.131 9.76101 13.1301 10.2359 13.4224 10.5293C14.586 11.6975 14.5547 13.8087 13.1194 15.2496L8.27178 20.1161C6.83745 21.556 4.73937 21.5863 3.57791 20.4203C2.41424 19.2521 2.44559 17.1408 3.88089 15.6999L6.30473 13.2667C6.59706 12.9732 6.59614 12.4984 6.30268 12.206C6.00922 11.9137 5.53434 11.9146 5.24202 12.2081L2.81818 14.6413C0.906876 16.5601 0.666916 19.6234 2.51519 21.4789C4.36567 23.3365 7.42221 23.0944 9.33449 21.1747L14.1821 16.3082C16.0934 14.3895 16.3334 11.3262 14.4851 9.47074Z"
                fill="#1C274C"
            />
        </svg>,
    ];
    const news = [
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="icomoon-ignore"></g>
            <path
                d="M9.069 2.672v14.928h-6.397c0 0 0 6.589 0 8.718s1.983 3.010 3.452 3.010c1.469 0 16.26 0 20.006 0 1.616 0 3.199-1.572 3.199-3.199 0-1.175 0-23.457 0-23.457h-20.259zM6.124 28.262c-0.664 0-2.385-0.349-2.385-1.944v-7.652h5.331v7.192c0 0.714-0.933 2.404-2.404 2.404h-0.542zM28.262 26.129c0 1.036-1.096 2.133-2.133 2.133h-17.113c0.718-0.748 1.119-1.731 1.119-2.404v-22.12h18.126v22.391z"
                fill="#000000"
            ></path>
            <path
                d="M12.268 5.871h13.861v1.066h-13.861v-1.066z"
                fill="#000000"
            ></path>
            <path
                d="M12.268 20.265h13.861v1.066h-13.861v-1.066z"
                fill="#000000"
            ></path>
            <path
                d="M12.268 23.997h13.861v1.066h-13.861v-1.066z"
                fill="#000000"
            ></path>
            <path
                d="M26.129 9.602h-13.861v7.997h13.861v-7.997zM25.063 16.533h-11.729v-5.864h11.729v5.864z"
                fill="#000000"
            ></path>
        </svg>,
    ];
    const event = [
        <svg
            fill="#000000"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            viewBox="0 0 612 612"
        >
            <g>
                <g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M479.808,326.519c-73.02,0-132.228,59.227-132.228,132.229c0,72.983,59.208,132.174,132.228,132.174
             c72.984,0,132.192-59.19,132.192-132.174C612,385.745,552.792,326.519,479.808,326.519z M488.292,556.469v-11.415
             c0-4.722-3.808-8.538-8.484-8.538c-4.722,0-8.521,3.826-8.521,8.538v11.415c-47.341-4.07-85.158-41.896-89.229-89.229h11.451
             c4.677,0,8.502-3.809,8.502-8.484c0-4.758-3.825-8.521-8.502-8.521h-11.451c4.07-47.351,41.896-85.14,89.229-89.229v11.433
             c0,4.704,3.809,8.521,8.521,8.521c4.677,0,8.484-3.826,8.484-8.521v-11.433c47.359,4.089,85.177,41.878,89.229,89.229h-11.451
             c-4.703,0-8.502,3.771-8.502,8.521c0,4.686,3.808,8.484,8.502,8.484h11.451C573.478,514.572,535.651,552.389,488.292,556.469z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M529.066,445.966h-30.671c-4.089-5.897-10.881-9.813-18.588-9.813c-0.117,0-0.244,0.036-0.38,0.036l-27.948-39.346
             c-4.07-5.726-12.048-7.055-17.792-3.003c-5.726,4.089-7.101,12.084-3.003,17.828l27.967,39.363
             c-0.859,2.415-1.41,4.984-1.41,7.725c0,12.464,10.085,22.549,22.566,22.549c7.707,0,14.535-3.88,18.588-9.796h30.671
             c7.037,0,12.763-5.688,12.763-12.744C541.829,451.674,536.104,445.966,529.066,445.966z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M127.245,195.593c23.137,0,41.86-18.741,41.86-41.851V62.93c0-23.119-18.723-41.851-41.86-41.851
             c-23.119,0-41.833,18.732-41.833,41.851v90.821C85.412,176.852,104.125,195.593,127.245,195.593z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M383.578,195.593c23.138,0,41.86-18.741,41.86-41.851V62.93c0-23.119-18.723-41.851-41.86-41.851
             c-23.101,0-41.832,18.732-41.832,41.851v90.821C341.736,176.852,360.478,195.593,383.578,195.593z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M183.957,311.793c0-11.948-9.66-21.626-21.636-21.626h-40.105c-11.948,0-21.653,9.678-21.653,21.626v40.088
             c0,11.966,9.705,21.672,21.653,21.672h40.105c11.966,0,21.636-9.706,21.636-21.672V311.793z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M297.127,311.82c0-11.948-9.687-21.617-21.608-21.617h-40.124c-11.948,0-21.618,9.669-21.618,21.617v40.097
             c0,11.93,9.669,21.636,21.618,21.636h40.124c11.93,0,21.608-9.706,21.608-21.636V311.82z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M348.548,290.167c-11.967,0-21.654,9.678-21.654,21.626v40.088c0,10.826,8.068,19.365,18.416,20.984
             c15.864-24.711,38.332-44.719,64.934-57.653v-3.419c0-11.948-9.669-21.626-21.636-21.626H348.548z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M122.225,398.833c-11.948,0-21.654,9.669-21.654,21.617v40.105c0,11.948,9.706,21.617,21.654,21.617h40.124
             c11.948,0,21.608-9.669,21.608-21.617V420.45c0-11.948-9.66-21.617-21.608-21.617H122.225z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M275.473,398.851h-40.087c-11.948,0-21.617,9.688-21.617,21.636v40.069c0,11.948,9.669,21.617,21.617,21.617h40.087
             c11.93,0,21.618-9.669,21.618-21.617v-40.069C297.091,408.538,287.403,398.851,275.473,398.851z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M333.939,523.59H130.474c-35.022,0-63.523-28.5-63.523-63.486V247.592h376.958v55.608
             c11.551-2.659,23.518-4.215,35.899-4.215c10.619,0,20.984,1.095,31.033,3.094V102.204h-60.293v51.538
             c0,36.921-30.021,66.951-66.97,66.951c-36.93,0-66.95-30.029-66.95-66.951v-51.538H194.213v51.538
             c0,36.921-30.039,66.951-66.969,66.951c-36.913,0-66.951-30.029-66.951-66.951v-51.538H0v357.891
             c0,72.034,58.412,130.474,130.474,130.474h249.885c2.967,0,5.897-0.244,8.81-0.435
             C365.163,573.545,345.987,550.525,333.939,523.59z"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>,
    ];
    const complaint = [
        <svg
            fill="#000000"
            height="24px"
            width="24px"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 386.187 386.187"
        >
            <path
                d="M48.626,131.93c0.418,4.952,4.745,8.635,9.723,8.215c0.327-0.028,0.647-0.072,0.963-0.133
   c6.549,36.481,38.521,64.251,76.858,64.251s70.31-27.77,76.858-64.251c0.314,0.061,0.635,0.104,0.961,0.133
   c4.965,0.416,9.307-3.261,9.724-8.214l1.171-13.919c0.416-4.953-3.262-9.307-8.214-9.724c-1.532-0.128-3.003,0.134-4.319,0.703
   c-3.458-15.338-11.44-28.979-22.469-39.443c-0.032-0.036-0.064-0.071-0.098-0.106c-0.34-0.366-0.703-0.697-1.085-0.993
   c-13.88-12.643-32.32-20.358-52.529-20.358c-37.154,0-68.331,26.084-76.181,60.901c-1.315-0.569-2.78-0.83-4.318-0.703
   c-4.953,0.417-8.631,4.77-8.215,9.723L48.626,131.93z M136.17,66.09c11.915,0,23.03,3.485,32.381,9.491
   c-9.601,6.155-20.789,9.466-32.381,9.466c-5.385,0-10.727-0.713-15.876-2.119c-4.79-1.311-9.743,1.517-11.053,6.313
   c-1.309,4.795,1.518,9.743,6.313,11.053c6.693,1.827,13.63,2.754,20.616,2.754c16.78,0,32.907-5.337,46.26-15.176
   c8.633,10.406,13.826,23.759,13.826,38.305c0,33.132-26.954,60.087-60.086,60.087s-60.086-26.955-60.086-60.087
   S103.039,66.09,136.17,66.09z M144.559,124c0-4.971,4.029-9,9-9h10.001c4.971,0,9,4.029,9,9s-4.029,9-9,9h-10.001
   C148.588,133,144.559,128.971,144.559,124z M133.671,151h4.998c4.971,0,9,4.029,9,9s-4.029,9-9,9h-4.998c-4.971,0-9-4.029-9-9
   S128.701,151,133.671,151z M100.263,124c0-4.971,4.029-9,9-9h10c4.971,0,9,4.029,9,9s-4.029,9-9,9h-10
   C104.292,133,100.263,128.971,100.263,124z M291.887,92.778c0.04,4.971-3.956,9.222-8.927,9.222c-0.025,0-0.05,0-0.075,0
   c-4.937,0-8.958-4.13-8.998-9.076c-0.079-9.746,7.034-15.867,12.749-20.666c4.485-3.767,7.426-6.417,7.426-8.842
   c0-4.91-3.993-8.904-8.902-8.904c-4.913,0-8.906,3.994-8.906,8.904c0,4.971-4.029,9-9,9s-9-4.029-9-9
   c0-14.835,12.068-26.904,26.902-26.904c14.838,0,26.906,12.069,26.906,26.904c0,10.997-8.006,17.719-13.852,22.627
   C295.998,87.902,291.876,91.511,291.887,92.778z M260.624,376.292c0.134,1.157,0.039,2.295-0.254,3.372
   c-0.241,0.891-0.615,1.717-1.1,2.475c-0.002,0.003-0.004-0.014-0.007-0.01c-1.071,1.676-2.695,2.961-4.69,3.635
   c-0.291,0.099-0.587,0.103-0.89,0.171c-0.765,0.176-1.533,0.064-2.278,0.064h-75.252c-4.971,0-9-4.029-9-9s4.029-9,9-9h64.078
   l-23.773-97.646c-3.654-15.023-22.957-27.718-43.359-29.327c-6.951,11.05-21.069,18.31-36.688,18.31s-29.736-7.32-36.688-18.37
   c-20.402,1.609-39.705,14.374-43.357,29.397L32.591,368h64.076c4.971,0,9,4.029,9,9s-4.029,9-9,9h-75.25
   c-0.09,0-0.179,0.164-0.27,0.164c-0.663,0-1.336,0.085-2.01-0.068c-0.304-0.069-0.603-0.152-0.894-0.252
   c-1.979-0.67-3.595-1.98-4.665-3.639c-0.508-0.785-0.897-1.65-1.142-2.578c-0.277-1.048-0.369-2.149-0.244-3.272
   c0.05-0.466,0.136-0.905,0.254-1.346l26.428-108.676C44.791,241.999,73.396,223,103.997,223h1.237c3.845,0,7.265,2.395,8.513,6.032
   c2.119,6.173,10.584,12.376,22.664,12.376s20.545-6.218,22.664-12.391c1.248-3.637,4.668-6.017,8.513-6.017h1.236
   c30.6,0,59.205,18.999,65.124,43.332l26.428,108.65C260.49,375.409,260.573,375.843,260.624,376.292z M291.991,118.74
   c0,4.971-4.029,9.035-9,9.035s-8.943-3.995-8.943-8.966v-0.069c0-4.971,3.972-9,8.943-9S291.991,113.77,291.991,118.74z
    M374.048,39.052v86.867c0,21.275-17.757,39.081-39.032,39.081H251.8l-26.912,35.664c-1.768,2.358-4.472,3.37-7.208,3.37
   c-1.879,0-3.773-0.555-5.392-1.769c-3.978-2.981-4.784-8.561-1.803-12.537l29.612-39.375c1.7-2.268,4.368-3.353,7.201-3.353h87.717
   c11.35,0,21.032-9.731,21.032-21.081V39.052c0-11.35-9.683-21.052-21.032-21.052h-104.82c-11.351,0-20.585,9.41-20.585,20.759
   c0,4.971-4.029,9.175-9,9.175s-9-4.146-9-9.117C191.611,17.542,208.92,0,230.196,0h104.82C356.291,0,374.048,17.776,374.048,39.052z
   "
            />
        </svg>,
    ];
    const sms = [
        <svg
            fill="#000000"
            width="24px"
            height="24px"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z" />
        </svg>,
    ];
    const notice = [
        <svg
            fill="#000000"
            height="24px"
            width="24px"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            enable-background="new 0 0 64 64"
        >
            <g id="Bell">
                <path
                    d="M46.6674995,8.6586504c-0.5527992,0-1,0.4473-1,1c0,0.5527992,0.4472008,1,1,1
     c3.5185013,0,6.3808022,2.8622999,6.3808022,6.3809004c0,0.5527,0.4473,1,1,1c0.5527992,0,1-0.4473,1-1
     C55.0483017,12.4184504,51.2886009,8.6586504,46.6674995,8.6586504z"
                />
                <path
                    d="M8.9517002,17.0395508c0,0.5527,0.4471998,1,1,1c0.5527,0,1-0.4473,1-1
     c0-3.5186005,2.8622999-6.3809004,6.3808002-6.3809004c0.5527992,0,1-0.4472008,1-1c0-0.5527-0.4472008-1-1-1
     C12.7114,8.6586504,8.9517002,12.4184504,8.9517002,17.0395508z"
                />
                <path
                    d="M48.1431007,1.27785c-0.5527992,0-1,0.4473-1,0.9999999s0.4472008,1,1,1
     c6.7743988,0,12.2860985,5.5107002,12.2860985,12.2851c0,0.5527992,0.4473,1,1,1s1-0.4472008,1-1
     C62.4291992,7.6860499,56.0200005,1.27785,48.1431007,1.27785z"
                />
                <path
                    d="M16.8560009,2.2778499c0-0.5526999-0.4473-0.9999999-1.000001-0.9999999
     c-7.8769999,0-14.2852001,6.4081998-14.2852001,14.2851c0,0.5527992,0.4473001,1,1.0000001,1s1-0.4472008,1-1
     c0-6.7743998,5.5107002-12.2851,12.2852001-12.2851C16.4087009,3.2778499,16.8560009,2.83055,16.8560009,2.2778499z"
                />
                <path
                    d="M51.7932014,46.2020493c-0.1280022-0.3828011-0.3692017-0.6965981-0.6621017-0.9463997
     c0.0236015-0.6092987,0.0386009-1.2222977,0.0386009-1.8409996c0-13.6198997-5.641201-25.1546001-13.4345016-29.1104012
     c0.1161003-0.4706001,0.1844025-0.9601002,0.1844025-1.4666996c0-3.3774004-2.7380028-6.1154003-6.1154022-6.1154003
     s-6.1153984,2.7379999-6.1153984,6.1154003c0,0.5065994,0.0682983,0.9960995,0.1843987,1.4666996
     C18.0799007,18.2600498,12.4386997,29.7947502,12.4386997,43.41465c0,0.6187019,0.0150003,1.2317009,0.0386,1.8409996
     c-0.2929001,0.2498016-0.5340996,0.5635986-0.6620998,0.9463997l-2.8975,8.6665993
     c-0.4692001,1.4033012,0.5754004,2.8535004,2.0555,2.8535004h14.1247005c0.8610001,2.8908005,3.535799,5,6.7062988,5
     s5.8453026-2.1091995,6.7063026-5h14.1246986c1.4800987,0,2.5247002-1.4501991,2.0555-2.8535004L51.7932014,46.2020493z
      M26.7959003,16.1219501l1.4443989-0.7332001l-0.3878994-1.5727005c-0.0841999-0.3413-0.1252003-0.6613998-0.1252003-0.9784994
     c0-2.2480001,1.8290005-4.0769005,4.0769997-4.0769005s4.0769997,1.8289003,4.0769997,4.0769005
     c0,0.3170996-0.0410004,0.6371994-0.1251984,0.9784994l-0.3879013,1.5727005L36.8125,16.1219501
     c7.2531013,3.6816006,12.3186989,14.9046993,12.3186989,27.2926998c0,0.4183006-0.0060997,0.8419991-0.0181007,1.2691002
     H14.4953003c-0.0120001-0.4271011-0.0181007-0.8507996-0.0181007-1.2691002
     C14.4771996,31.0266495,19.5428009,19.8035507,26.7959003,16.1219501z M31.8041992,60.7221489
     c-2.0464001,0-3.8094997-1.2355003-4.5824986-3h9.164999C35.6137009,59.4866486,33.8506012,60.7221489,31.8041992,60.7221489z
      M52.7711983,55.6526489c-0.0500984,0.0695-0.1102982,0.0695-0.1359978,0.0695H38.8041992h-14H10.9731998
     c-0.0256996,0-0.0859003,0-0.1359997-0.0695c-0.0496998-0.0690994-0.0307999-0.1256981-0.0227003-0.1497993l2.8975-8.6665993
     c0.0229006-0.0681992,0.0866003-0.1141014,0.1588001-0.1141014h35.8667984c0.0722008,0,0.1359024,0.0459023,0.158802,0.1140022
     l2.8974991,8.6666985C52.8019981,55.5269508,52.8209,55.5835495,52.7711983,55.6526489z"
                />
            </g>
        </svg>,
    ];
    const feedback = [
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path fill="#444" d="M15 2v2h-9v-2h9zM16 1h-11v4h11v-4z"></path>
            <path fill="#444" d="M0 1h4v4h-4v-4z"></path>
            <path fill="#444" d="M15 7v2h-9v-2h9zM16 6h-11v4h11v-4z"></path>
            <path fill="#444" d="M0 6h4v4h-4v-4z"></path>
            <path fill="#444" d="M15 12v2h-9v-2h9zM16 11h-11v4h11v-4z"></path>
            <path fill="#444" d="M0 11h4v4h-4v-4z"></path>
        </svg>,
    ];
    const travel = [
        <svg
            fill="#000000"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            viewBox="0 0 52 52"
            enable-background="new 0 0 52 52"
        >
            <path d="M47,21 L42.48,8.84 C41.76,6.52 39.6,5 37.2,5 L14.8,5 C12.4,5 10.24,6.52 9.44,8.84 L5,21 C2.92,21.56 2,23.56 2,25.8 L2,37.4 C2,39.48 4.16,41.28 6,42 L6,46.0334473 C6,47.3444824 6.67423503,48 8.02270508,48 L13.050293,48 C14.3500977,48 15,47.3444824 15,46.0334473 L15,42 L37,42 L37,46.0334473 C37,47.3444824 37.6625977,48 38.987793,48 L44.0212402,48 C45.3404134,48 46,47.3444824 46,46.0334473 L46,41.96 C47.84,41.32 50,39.56 50,37.4 L50,25.8 C50,23.56 49.08,21.56 47,21 Z M11,34 C8.76,34 7,32.24 7,30 C7,27.76 8.76,26 11,26 C13.24,26 15,27.76 15,30 C15,32.24 13.24,34 11,34 Z M27.6,21 L11.76,21 C11.2,21 10.84,20.48 11,20 L14,11 C14.08,10.68 14.289856,10 15,10 L37,10 C37.7802124,10 37.92,10.76 38,11 L41,20 C41.2,20.6424561 40.880127,21 40.08,21 L27.6,21 Z M41,34 C38.76,34 37,32.24 37,30 C37,27.76 38.76,26 41,26 C43.24,26 45,27.76 45,30 C45,32.24 43.24,34 41,34 Z" />
        </svg>,
    ];
    const discount = [
        <svg
            fill="#000000"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M21 5H3a1 1 0 0 0-1 1v4h.893c.996 0 1.92.681 2.08 1.664A2.001 2.001 0 0 1 3 14H2v4a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-4h-1a2.001 2.001 0 0 1-1.973-2.336c.16-.983 1.084-1.664 2.08-1.664H22V6a1 1 0 0 0-1-1zM9 9a1 1 0 1 1 0 2 1 1 0 1 1 0-2zm-.8 6.4 6-8 1.6 1.2-6 8-1.6-1.2zM15 15a1 1 0 1 1 0-2 1 1 0 1 1 0 2z" />
        </svg>,
    ];
    const gallery = [
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8Z"
                fill="#1C274C"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.0574 1.25H11.9426C9.63424 1.24999 7.82519 1.24998 6.41371 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63422 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.41371 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V11.9426C22.75 9.63423 22.75 7.82519 22.5603 6.41371C22.366 4.96897 21.9607 3.82895 21.0659 2.93414C20.1711 2.03933 19.031 1.63399 17.5863 1.43975C16.1748 1.24998 14.3658 1.24999 12.0574 1.25ZM3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62178 2.75 12 2.75C14.3782 2.75 16.0864 2.75159 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2484 7.91356 21.25 9.62178 21.25 12C21.25 12.4502 21.2499 12.8764 21.2487 13.2804L21.0266 13.2497C18.1828 12.8559 15.5805 14.3343 14.2554 16.5626C12.5459 12.2376 8.02844 9.28807 2.98073 10.0129L2.75497 10.0454C2.76633 8.63992 2.80368 7.52616 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948Z"
                fill="#1C274C"
            />
        </svg>,
    ];
    const ads = [
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7ZM10 14V15C10 15.5523 10.4477 16 11 16C11.5523 16 12 15.5523 12 15V11C12 9.34315 10.6569 8 9 8C7.34315 8 6 9.34315 6 11V15C6 15.5523 6.44772 16 7 16C7.55228 16 8 15.5523 8 15V14H10ZM18 9C18 8.44772 17.5523 8 17 8C16.4477 8 16 8.44772 16 9V11H15.5C14.7287 11 14.0767 11.2992 13.6276 11.8044C13.1949 12.2912 13 12.9119 13 13.5C13 14.0881 13.1949 14.7088 13.6276 15.1956C14.0766 15.7008 14.7286 16 15.5 16H17C17.5523 16 18 15.5523 18 15V12.0065L18 12L18 11.9935V9Z"
                fill="#323232"
            />
            <path
                d="M15.5 13H16V14H15.5C15.2714 14 15.1734 13.9242 15.1224 13.8669C15.0551 13.7912 15 13.6619 15 13.5C15 13.3381 15.0551 13.2088 15.1224 13.1331C15.1734 13.0758 15.2714 13 15.5 13Z"
                fill="#323232"
            />
            <path
                d="M9 10C8.44772 10 8 10.4477 8 11V12H10V11C10 10.4477 9.55228 10 9 10Z"
                fill="#323232"
            />
        </svg>,
    ];
    const category = [
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.6695 2H16.7695C14.5895 2 13.4395 3.15 13.4395 5.33V7.23C13.4395 9.41 14.5895 10.56 16.7695 10.56H18.6695C20.8495 10.56 21.9995 9.41 21.9995 7.23V5.33C21.9995 3.15 20.8495 2 18.6695 2Z"
                fill="#292D32"
            />
            <path
                d="M7.24 13.4297H5.34C3.15 13.4297 2 14.5797 2 16.7597V18.6597C2 20.8497 3.15 21.9997 5.33 21.9997H7.23C9.41 21.9997 10.56 20.8497 10.56 18.6697V16.7697C10.57 14.5797 9.42 13.4297 7.24 13.4297Z"
                fill="#292D32"
            />
            <path
                d="M6.29 10.58C8.6593 10.58 10.58 8.6593 10.58 6.29C10.58 3.9207 8.6593 2 6.29 2C3.9207 2 2 3.9207 2 6.29C2 8.6593 3.9207 10.58 6.29 10.58Z"
                fill="#292D32"
            />
            <path
                d="M17.7099 22.0019C20.0792 22.0019 21.9999 20.0812 21.9999 17.7119C21.9999 15.3426 20.0792 13.4219 17.7099 13.4219C15.3406 13.4219 13.4199 15.3426 13.4199 17.7119C13.4199 20.0812 15.3406 22.0019 17.7099 22.0019Z"
                fill="#292D32"
            />
        </svg>,
    ];
    const analystics = [
        <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="SVGRepo_bgCarrier" stroke-width="0" />

            <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
            />

            <g id="SVGRepo_iconCarrier">
                <path
                    d="M20 13.75C20 13.3358 19.6642 13 19.25 13H16.25C15.8358 13 15.5 13.3358 15.5 13.75V20.5H14V4.25C14 3.52169 13.9984 3.05091 13.9518 2.70403C13.908 2.37872 13.8374 2.27676 13.7803 2.21967C13.7232 2.16258 13.6213 2.09197 13.296 2.04823C12.9491 2.00159 12.4783 2 11.75 2C11.0217 2 10.5509 2.00159 10.204 2.04823C9.87872 2.09197 9.77676 2.16258 9.71967 2.21967C9.66258 2.27676 9.59196 2.37872 9.54823 2.70403C9.50159 3.05091 9.5 3.52169 9.5 4.25V20.5H8V8.75C8 8.33579 7.66421 8 7.25 8H4.25C3.83579 8 3.5 8.33579 3.5 8.75V20.5H2H1.75C1.33579 20.5 1 20.8358 1 21.25C1 21.6642 1.33579 22 1.75 22H21.75C22.1642 22 22.5 21.6642 22.5 21.25C22.5 20.8358 22.1642 20.5 21.75 20.5H21.5H20V13.75Z"
                    fill="#1C274C"
                />
            </g>
        </svg>,
    ];
    return (
        <>
            <div className="brand text-right">
                <img src={"./images/logo.png"} alt="" />
                <span>پنل ادمین پارکوپلو</span>
            </div>
            <hr />
            <Menu theme="light" mode="inline">
                <Menu.Item key="14">
                    <NavLink to="/admin">
                        <span
                            className="icon"
                            style={{
                                background: page === "admin" ? color : "",
                            }}
                        >
                            {admin}
                        </span>
                        <span className="label">مدیریت ادمین ها</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="19">
                    <NavLink to="/users">
                        <span
                            className="icon"
                            style={{
                                background: page === "users" ? color : "",
                            }}
                        >
                            {users}
                        </span>
                        <span className="label">مدیریت کاربران</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="17">
                    <NavLink to="/analytics">
                        <span
                            className="icon"
                            style={{
                                background: page === "analytics" ? color : "",
                            }}
                        >
                            {analystics}
                        </span>
                        <span className="label">گزارش گیری</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item
                    style={{ marginTop: "1.5rem" }}
                    onClick={handleShowOstan}
                    key="1"
                >
                    <NavLink to="/geo">
                        <span
                            className="icon"
                            style={{
                                background: page === "geo" ? color : "",
                            }}
                        >
                            {iran}
                        </span>
                        <span className="label">مدیریت ژئویونیت</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="4">
                    <NavLink to="/content">
                        <span
                            className="icon"
                            style={{
                                background: page === "content" ? color : "",
                            }}
                        >
                            {content}
                        </span>
                        <span className="label">مدیریت محتوا</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="5">
                    <NavLink to="/place">
                        <span
                            className="icon"
                            style={{
                                background: page === "place" ? color : "",
                            }}
                        >
                            {place}
                        </span>
                        <span className="label">مدیریت مکان ها</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="6">
                    <NavLink to="/linkestan">
                        <span
                            className="icon"
                            style={{
                                background: page === "linkestan" ? color : "",
                            }}
                        >
                            {link}
                        </span>
                        <span className="label">مدیریت لینکستان</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="7">
                    <NavLink to="/news">
                        <span
                            className="icon"
                            style={{
                                background: page === "news" ? color : "",
                            }}
                        >
                            {news}
                        </span>
                        <span className="label">مدیریت اخبار</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="8">
                    <NavLink to="/events">
                        <span
                            className="icon"
                            style={{
                                background: page === "events" ? color : "",
                            }}
                        >
                            {event}
                        </span>
                        <span className="label">مدیریت رویدادها</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="9">
                    <NavLink to="/complaints">
                        <span
                            className="icon"
                            style={{
                                background: page === "complaints" ? color : "",
                            }}
                        >
                            {complaint}
                        </span>
                        <span className="label">مدیریت شکایات</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="10">
                    <NavLink to="/interactions">
                        <span
                            className="icon"
                            style={{
                                background:
                                    page === "interactions" ? color : "",
                            }}
                        >
                            {sms}
                        </span>
                        <span className="label">مدیریت پیامک</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="11">
                    <NavLink to="/notice">
                        <span
                            className="icon"
                            style={{
                                background: page === "notice" ? color : "",
                            }}
                        >
                            {notice}
                        </span>
                        <span className="label">مدیریت اعلان ها</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="12">
                    <NavLink to="/feedBack">
                        <span
                            className="icon"
                            style={{
                                background: page === "feedBack" ? color : "",
                            }}
                        >
                            {feedback}
                        </span>
                        <span className="label">مدیریت نظرسنجی</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="13">
                    <NavLink to="/travelSuggestion">
                        <span
                            className="icon"
                            style={{
                                background:
                                    page === "travelSuggestion" ? color : "",
                            }}
                        >
                            {travel}
                        </span>
                        <span className="label">مدیریت پیشنهاد سفر</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="15">
                    <NavLink to="/discount">
                        <span
                            className="icon"
                            style={{
                                background: page === "discount" ? color : "",
                            }}
                        >
                            {discount}
                        </span>
                        <span className="label">تخفیفستان</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="16">
                    <NavLink to="/gallery">
                        <span
                            className="icon"
                            style={{
                                background: page === "gallery" ? color : "",
                            }}
                        >
                            {gallery}
                        </span>
                        <span className="label">مدیریت نگارخانه</span>
                    </NavLink>
                </Menu.Item>
                <Menu.Item key="17">
                    <NavLink to="/ads">
                        <span
                            className="icon"
                            style={{
                                background: page === "ads" ? color : "",
                            }}
                        >
                            {ads}
                        </span>
                        <span className="label">مدیریت تبلیغات</span>
                    </NavLink>
                </Menu.Item>
                <Menu.SubMenu key="sub1" title="مدیریت دسته بندی ها">
                    <Menu.Item key="2">
                        <NavLink to="/placeCategories">
                            <span
                                className="icon"
                                style={{
                                    background:
                                        page === "placeCategories" ? color : "",
                                }}
                            >
                                {category}
                            </span>
                            <span className="label">دسته بندی مکان ها</span>
                        </NavLink>
                    </Menu.Item>
                    <Menu.Item key="3">
                        <NavLink to="/contentCategories">
                            <span
                                className="icon"
                                style={{
                                    background:
                                        page === "contentCategories"
                                            ? color
                                            : "",
                                }}
                            >
                                {category}
                            </span>
                            <span className="label">دسته بندی محتوا</span>
                        </NavLink>
                    </Menu.Item>
                </Menu.SubMenu>
                <Link to="/sign-in">
                    <Button
                        style={{
                            backgroundColor: "#DE3E3E",
                            width: "100%",
                            margin: "1rem 0",
                            color: "white",
                        }}
                        onClick={() => {
                            localStorage.removeItem("user");
                        }}
                    >
                        خروج
                    </Button>
                </Link>
            </Menu>
        </>
    );
}

export default Sidenav;
